import styled from "styled-components";
import TimelineViewConfig from "./TimelineViewConfig";

export enum SeparatorMode {
	EMPTY,
	HALF,
	FULL
}

export const Bar = styled.div`
	display: flex;
	align-items: center;
`;

export const Node = styled.div<{config: TimelineViewConfig, active: boolean}>`
	flex: 1;
	height: ${({config}) => config.nodeSize + "px"};
	max-width: ${({config}) => config.nodeSize + "px"};
	border-radius: ${({config}) => config.nodeSize + "px"};
	background: ${({config, active}) => active ? config.activeColor : config.inactiveColor};
	z-index: 15;
`;

export const Separator = styled.div<{config: TimelineViewConfig, mode: SeparatorMode}>`
	flex: ${({config}) => config.spacerLength};
	height: ${({config}) => config.spacerHeight + "px"};

	${({mode, config}) => SeparatorMode.HALF === mode && `
		background: linear-gradient(90deg, ${config.activeColor} 50%, ${config.inactiveColor} 50%);
	`}

	${({mode, config}) => SeparatorMode.EMPTY === mode && `
		background: ${config.inactiveColor};
	`}

	${({mode, config}) => SeparatorMode.FULL === mode && `
		background: ${config.activeColor};
	`}

	z-index: 10;
	margin: 0 -5px;
`;

export const Legend = styled.div`
	display: flex;
	align-items: center;
`;

export const Label = styled.div`
	flex: 1;
`;

export const LabelSpacer = styled.div<{config: TimelineViewConfig}>`
	flex: ${({config}) => config.spacerLength};
`;



// WEBPACK FOOTER //
// ./src/common/views/timeline/styled.tsx